// extracted by mini-css-extract-plugin
module.exports = {"youtube_embed":"youtube-embed_youtube_embed__q0tM9"};